export interface EstablishmentSummary {
  id: string;
  name: string;
  roles: string[];
}

/**
 * Condomínio cujos papéis valem para a sessão atual.
 *
 * Os gates de tela (ex.: botão "Novo Compromisso" na Agenda do Síndico) precisam
 * olhar o condomínio SELECIONADO — o mesmo que vai no header `x-establishment-id`
 * das requests. Usar `establishments[0]` avaliava o síndico de vários condomínios
 * com os papéis de um condomínio que não é o que ele está vendo na tela.
 */
export const resolveActiveEstablishment = <T extends EstablishmentSummary>(
  establishments: T[] | undefined,
  selectedEstablishmentId: string | null | undefined,
): T | undefined => {
  if (!establishments?.length) {
    return undefined;
  }

  const selected = selectedEstablishmentId
    ? establishments.find(
        (establishment) => establishment.id === selectedEstablishmentId,
      )
    : undefined;

  return selected ?? establishments[0];
};

/**
 * Todos os papéis do usuário no condomínio ativo.
 *
 * O backend permite mais de um papel por vínculo (um síndico que também é
 * morador, p.ex.). Ficar só com `roles[0]` descartava papéis silenciosamente e
 * a ordem do array não é garantida — nenhum `ORDER BY` no backend —, então o
 * papel preservado era efetivamente arbitrário.
 */
export const resolveActiveRoles = (
  establishments: EstablishmentSummary[] | undefined,
  selectedEstablishmentId: string | null | undefined,
): string[] =>
  resolveActiveEstablishment(establishments, selectedEstablishmentId)?.roles ??
  [];
